import { render, staticRenderFns } from "./v-navbar-icon.vue?vue&type=template&id=0d3987f0&"
import script from "./v-navbar-icon.vue?vue&type=script&lang=js&"
export * from "./v-navbar-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports